import React from "react";

import data from "../../../data/Home-page/content";
import Reveal from "../../../components/Reveal";

function renderVision(vision) {
  const marker = "women led";
  const idx = vision.toLowerCase().indexOf(marker);
  if (idx === -1) return vision;
  return (
    <>
      {vision.slice(0, idx)}
      <span className="text-gold-700 font-semibold">{vision.slice(idx, idx + marker.length)}</span>
      {vision.slice(idx + marker.length)}
    </>
  );
}

const ITEMS = [
  { heading: "Our Mission", text: (d) => d.mission },
  { heading: "Our Vision", text: (d) => renderVision(d.vision) },
  { heading: "Our Values", text: (d) => d.valuesSummary },
];

export default function MissionVisionValues() {
  return (
    <div className="max-w-6xl mx-auto px-6">
      <div className="grid grid-cols-1 md:grid-cols-3 md:gap-6">
        {ITEMS.map((item, i) => (
          <Reveal key={item.heading} delay={i * 150}>
            <div className="text-center py-6 md:py-10 md:px-8 md:h-full md:rounded-[1.75rem] md:border md:border-brown-500/40 md:bg-[radial-gradient(ellipse_at_center,_#FDFAF5_0%,_#EDE0C8_60%,_#B8A88F_100%)]">
              <h3 className="font-heading text-maroon-800 text-xl sm:text-2xl tracking-wide mb-4">
                {item.heading}
              </h3>
              <p className="font-body font-medium text-maroon-900/90 text-sm sm:text-base leading-relaxed">
                {item.text(data)}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
